import { LocaleEnum } from '@/types/enum/locale.enum';
import { defineRouting } from 'next-intl/routing';

export const AVAILABLE_LOCALES: LocaleEnum[] = [LocaleEnum.FR_BE, LocaleEnum.NL_BE];

export const routing = defineRouting({
	// A list of all locales that are supported
	locales: AVAILABLE_LOCALES,

	// Used when no locale matches
	defaultLocale: LocaleEnum.FR_BE,
});
